<template>
    <div>
         <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="分期还款表" name="first">
                <div class="container">
            <table width="100%">
                <tr>
                    <td colspan="9">典当续当协议{{Data.isType?'(1+N)':'(0+N)'}}</td>
                </tr>
                <tr>
                    <td colspan="9">当户 {{Data.name}} / {{Data.piaonum}} 汽车典当分期续当计划表，约定详见如下表格</td>
                </tr>
                <tr>
                    <td width="10%">续当期数</td>
                    <td width="10%">本金</td>
                    <td width="15%">{{Data.sum}}</td>
                    <td width="10%"></td>
                    <td width="10%">综合费</td>
                    <td width="10%">典当利息</td>
                    <td width="15%" rowspan="2">付款日期</td>
                    <td width="10%" rowspan="2">应付金额（不含利息）</td>
                    <td width="10%" rowspan="2">综合费率 （含利息）</td>
                </tr>
                <tr>
                    <td>{{Data.command}}</td>
                    <td></td>
                    <td>每期归还本金</td>
                    <td>剩余本金</td>
                    <td>{{Data.priceZ + '%' || '2.0%'}}</td>
                    <td>{{Data.interest + '%' || '0.28%'}}</td>
                </tr>
                <tr v-if="Data.isType">
                    <td></td>
                    <td>建当首期</td>
                    <td>0</td>
                    <td>{{Data.sum}}</td>
                    <td>{{Math.trunc(Data.sum * (Data.priceZ / 100))}}</td>
                    <td>{{Math.trunc(Data.sum * (Data.interest / 100))}}</td>
                    <td>{{Data.startDate}}</td>
                    <td>{{Data.sum}}</td>
                    <td>{{((((Data.sum*(Data.priceZ / 100)) + (Data.sum*(Data.interest / 100)))  / Data.sum )*100).toFixed(2) + '%'}}</td>
                </tr>
            </table>

            <!-- 循环每期还款 -->
            <table width="100%" v-for="item in arrNum" :key="item">
                <tr>
                    <td width="10%"></td>
                    <td width="10%">第{{item}}期</td>
                    <td width="15%">{{Math.trunc(Data.sum/Data.command) }}</td>
                    <td width="10%">{{Data.sum - Math.trunc(Data.sum/Data.command*item)}}</td>
                    <td width="10%">{{Math.trunc((Data.sum - Math.trunc(Data.sum/Data.command*item)) * (Data.priceZ / 100))}}</td>
                    <td width="10%">{{Math.trunc((Data.sum - Math.trunc(Data.sum/Data.command*item)) * (Data.interest / 100))}}</td>
                    <td width="15%">{{payDate(item*30)}}</td>
                    <td width="10%">{{Math.trunc(Data.sum/Data.command) + Math.trunc((Data.sum - Math.trunc(Data.sum/Data.command*item)) * (Data.priceZ / 100))}}</td>
                    <td width="10%">{{ ((((Number(Math.trunc((Data.sum - Math.trunc(Data.sum/Data.command*item)) * (Data.priceZ / 100))) + Number(Math.trunc((Data.sum - Math.trunc(Data.sum/Data.command*item)) * (Data.interest / 100)))) / Number(Data.sum - Math.trunc(Data.sum/Data.command*item)))*100).toFixed(2) + '%') }}</td>
                </tr>
            </table>
        </div>
            </el-tab-pane>
            <el-tab-pane label="还款详情" name="second" >
        <div class="con_detail"  v-loading="loading" element-loading-text="网速有点慢，数据请求中...">
                       <table width="100%">
                <tr>
                    <td colspan="9">典当续当协议{{Data.isType?'(1+N)':'(0+N)'}}</td>
                </tr>
                <tr>
                    <td colspan="9">当户 {{Data.name}} / {{Data.piaonum}} 汽车典当分期续当计划表，约定详见如下表格</td>
                </tr>
                <tr>
                    <td width="10%">续当期数</td>
                    <td width="10%">本金</td>
                    <td width="15%">{{Data.sum}}</td>
                    <td width="10%"></td>
                    <td width="10%">综合费</td>
                    <td width="10%">典当利息</td>
                    <td width="15%" rowspan="2">实际还款日期</td>
                    <td width="10%" rowspan="2">实付金额</td>
                    <td width="10%" rowspan="2">综合费率</td>
                </tr>
                <tr>
                    <td>{{Data.command}}</td>
                    <td></td>
                    <td>每期归还本金</td>
                    <td>剩余本金</td>
                    <td>{{Data.priceZ + '%'}}</td>
                    <td>{{Data.interest + '%'}} </td>
                </tr>
                <tr v-if="Data.isType">
                    <td></td>
                    <td>建当首期</td>
                    <td>0</td>
                    <td>{{Data.sum}}</td>
                    <td>{{Data.sum * (Data.priceZ / 100)}}</td>
                    <td>{{(Data.sum * (Data.interest / 100)).toFixed(2)}}</td>
                    <td>{{Data.startDate}}</td>
                    <td>{{Data.sum * (Data.priceZ / 100)}}</td>
                    <td>{{((Data.sum*(Data.priceZ / 100) / Data.sum )*100).toFixed(2) + '%'}}</td>
                </tr>
            </table>

            <!-- 循环每期还款 -->
            <table width="100%" v-for="(item,index) in payDetailsData" :key="index">
                <tr>
                    <td width="10%"></td>
                    <td width="10%">第{{index+1}}期</td>
                    <td width="15%">{{Math.round(Data.sum/Data.command) }}</td>
                    <td width="10%">{{Data.sum - Math.round(Data.sum/Data.command*(index+1))}}</td>
                    <td width="10%">{{item.xupri}}</td>
                    <td width="10%">{{(index+1)==Data.command? lx : Math.round((Data.sum - Math.round(Data.sum/Data.command*(index+1)))*0.003)}}</td>
                    <td width="15%">{{item.xuday}}</td>
                    <td width="10%">{{item.rece}}</td>
                    <td width="10%">{{(index+1)>Data.command/2? (item.xupri / (Data.sum - Math.round(Data.sum/Data.command*(index+1)))*100).toFixed(2) + '%' : (item.xupri / (Data.sum - Math.round(Data.sum/Data.command*(index+1)))*100).toFixed(2) + '%'}}</td>
                </tr>
            </table>
        </div>
            </el-tab-pane>
    
            </el-tabs>
        
    </div>
 
</template>
<script>
import dayjs from "dayjs";
export default {
    name:"CheckPlan",
    
    data() {
        return {
            arrNum:[],
            activeName:'first',
            lx:0,
            loading:true,
            payDetailsData:[]
        }
    },

    props:['Data','token','env'],

    //监听数据变化
    watch: {
    Data () {
    let com  = Number(this.Data.command)+1
      let arr = []
        for(let i=1;i<com;i++){
            this.arrNum = i ;

            arr.push(Math.round((this.Data.sum - Math.round(this.Data.sum/this.Data.command*i))*0.003))

        }
        this.lx = this.Sum(arr)

        this.activeName = 'first'
     
    },
  },
  
  methods:{
       handleClick(tab) {
        this.activeName = tab.name
        if(tab.name == 'second'){
            this.loading = true
                    this.axios
                .post("/api/tcb/databasequery?access_token=" + this.token, {
                env: `${this.env}`,
                query:
                    `db.collection("yxus_record").where({ticketnumber:_.eq("${this.Data.piaonum}"),stas:_.eq("分期还款").or(_.eq("建当"))}).limit(1000).get()`,
                }).then(res=>{

                    res.data.data.forEach((element, index, array) => {
                    array[index] = JSON.parse(element);
                });
                if(this.Data.isType == true){
                    let payDetails =  res.data.data.filter(item=>{
                        return item.stas == '分期还款'
                    })
                     this.payDetailsData = payDetails

                }else{
                    this.payDetailsData = res.data.data
                }
                    
                    this.loading = false
                }) 
        }
      },

      //计算付款日期
    payDate(event){
      if(this.Data.isType){
            let newDate = dayjs(this.Data.startDate).add(29,'day').format('YYYY-MM-DD')
            if(event == 30){
                
                return newDate
            }
         return dayjs(newDate).add(event-30,'day').format('YYYY-MM-DD')
      }else{
          let newDate = dayjs(this.Data.startDate).add(29,'day').format('YYYY-MM-DD')

        if(event == 60){
            
            return newDate
        }else if(event > 60){
             let addDate = event-60
            return dayjs(newDate).add(addDate,'day').format('YYYY-MM-DD')
        }

        return this.Data.startDate


      }
     
    },
    //实际还款日期
    // payDetails(events,piaonum){
    //     if(this.activeName == 'second'){
    //         if(events==1){
    //             return 666
    //         }
           

    //     }

        

    // },

      //典当总利息求和
  Sum(event){
      let s = 0;
      for( let i in event){
          s += event[i];
          s += "+"
      }
       s = s.substring(0, s.length - 1);
       return eval(s) || 0;
  },

  },



    created(){
  
       
    },
    mounted(){
        let com = Number(this.Data.command) + 1
        let arr = []
        for(let i=1;i<com;i++){
            this.arrNum = i
           
          arr.push(Math.round((this.Data.sum - Math.round(this.Data.sum/this.Data.command*i))*0.003))

        }
      this.lx = this.Sum(arr)
     
        setTimeout(()=>{
            console.log(this.Data)
        },2000)
    },
}
</script>
<style scoped>
    table {
  border-collapse: collapse;
}
td {
  height: 35px;
  border: 1px solid black;
  font-size: 18px;
  text-align: center;
}
</style>